var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,18.9h-4c-1.4,0-2.6-0.5-3.6-1.5c-0.9-1-1.3-2.3-1.2-3.7c0,0,0,0,0,0C3,10.2,6.1,7.4,9.6,7.4 c3.2,0,6.3,2.6,6.8,5.7c0.3,1.5-0.1,3-1,4C14.4,18.3,13,18.9,11.5,18.9z M4.2,13.8L4.2,13.8c-0.1,1,0.2,1.8,0.8,2.5 c0.6,0.7,1.5,1,2.4,1h4c1.1,0,2-0.4,2.7-1.2c0.6-0.8,0.9-1.8,0.7-2.8c-0.4-2.4-2.8-4.5-5.3-4.5C6.9,8.9,4.5,11.1,4.2,13.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,6.8C7,6.8,5.7,5.5,5.7,4c0-1.6,1.3-2.8,2.8-2.8s2.8,1.3,2.8,2.8C11.4,5.5,10.1,6.8,8.5,6.8z M8.5,2.6 C7.8,2.6,7.2,3.2,7.2,4c0,0.7,0.6,1.3,1.3,1.3S9.9,4.7,9.9,4C9.9,3.2,9.3,2.6,8.5,2.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.2,7.8c-1.3,0-2.4-1.1-2.4-2.4S12.9,3,14.2,3c1.3,0,2.4,1.1,2.4,2.4S15.6,7.8,14.2,7.8z M14.2,4.5 c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9C15.1,4.9,14.7,4.5,14.2,4.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.3,11.1c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S18.4,11.1,17.3,11.1z M17.3,8.6c-0.3,0-0.5,0.2-0.5,0.5 s0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5S17.6,8.6,17.3,8.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.1,9.5C1.8,9.5,0.7,8.4,0.7,7s1.1-2.4,2.4-2.4S5.5,5.7,5.5,7S4.4,9.5,3.1,9.5z M3.1,6.1 C2.6,6.1,2.2,6.5,2.2,7S2.6,8,3.1,8C3.6,8,4,7.5,4,7S3.6,6.1,3.1,6.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPet);
export default __webpack_public_path__ + "static/media/pet.134ac030da2fb6a4b57195e7a75ccabf.svg";
export { ForwardRef as ReactComponent };